import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Media } from "reactstrap";
import { H2, P } from "../../../AbstractElements";
import sad from "../../../assets/images/other-images/sad.png";

const Error403 = () => {
  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="error-wrapper">
          <Container>
            <Media body className="img-100" src={sad} alt="" />
            <div className="error-heading">
              <H2 attrH2={{ className: "headline font-success" }}>{"403"}</H2>
            </div>
            <Col md="8 offset-md-2">
              <P attrPara={{ className: "sub-content" }}>
                {"Bạn không có quyền truy cập"}
              </P>
            </Col>
            <Link to={"/"}>
              <Button color="success-gradien" size="lg">
                Trang chủ
              </Button>
            </Link>
          </Container>
        </div>
      </div>
    </Fragment>
  );
};

export default Error403;
